import Vue from 'vue';
import Vuex from 'vuex';

// eslint-disable-next-line import/no-cycle
import { AuthState } from './modules/Auth';

Vue.use(Vuex);

export interface RootState {
  auth: AuthState;
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<RootState>({});
